<template>
  <dv-loading class="dataView-loading" v-if="show">
    Loading...
  </dv-loading>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  mounted() {},
}
</script>

<style></style>
